import { takeEvery, call, put } from "redux-saga/effects";
import { SubmissionError } from "redux-form";
import { isRequired, validateValues } from "../../../utils/validation";
import { submitFormRoutine } from "../../actions/formRoutines/paymentAuthorization";
import ProfileService from "../../../services/profile";
import {authorizationActionCreators} from "../../actions/authorization";

function* validate({ payload: { values } }) {
  const errors = validateValues(values, {
    firstName: [ isRequired ],
    lastName: [ isRequired ],
    email: [ isRequired ],
  });

  if (errors) {
    yield put(submitFormRoutine.failure(new SubmissionError(errors)));
  } else {
    yield call(sendFormDataToServer, values);
  }

  yield put(submitFormRoutine.fulfill());
}

function* saveClientInfo({ payload: response }) {
  yield put(authorizationActionCreators.updateClient(response));
}

function* sendFormDataToServer(values) {
  try {
    yield put(submitFormRoutine.request());

    const payload = yield call(ProfileService.updateProfile, values);
    yield saveClientInfo({ payload });
    yield put(submitFormRoutine.success());

  } catch (error) {
    yield put(submitFormRoutine.failure(new SubmissionError({ _error: "Authentication failed" })));
  }
}

export default [
  takeEvery(submitFormRoutine.TRIGGER, validate),
];
